import { Dispatch } from '@reduxjs/toolkit';
import { AnyAction } from 'redux-saga';
import { zooluxCallCenterAPI } from '../../../zooluxCallCenterAPI';

const userAPI = zooluxCallCenterAPI.injectEndpoints({
    endpoints: (builder) => ({
        createUserRole: builder.mutation<any, any>({
            query: (body) => {
                return {
                    url: '/user-role/create',
                    method: 'POST',
                    body
                };
            },
            async onQueryStarted(_, { dispatch, queryFulfilled }: {
                dispatch: Dispatch<AnyAction>,
                queryFulfilled: Promise<{ data: any; }>,
            }) {
                try { } catch (error) {
                    console.error("Error fetching createUserRole:", error);
                }
            },
            invalidatesTags: ["UserAdmin"]
        }),
    }),
    overrideExisting: false,
});

export const { useCreateUserRoleMutation } = userAPI;